import { Validators } from '@angular/forms';
import { CurrencyInfo } from '@app/generated-api';
import { PaymentRequestStatus } from '@models/request';
import { PersistentFormControl, PersistentFormGroup } from '@utility/persistent-forms';
import { maxLengthValidator, notWhitespaceValidator } from '@utility/utility.validators';

export class DeductedFormGroup extends PersistentFormGroup<{
    deducted: PersistentFormControl<number | null>;
    deductedUsd: PersistentFormControl<number | null>;
    deductedCurrency: PersistentFormControl<CurrencyInfo | null>;
}> {
    constructor() {
        super({
            deducted: new PersistentFormControl<number | null>(null, [
                Validators.required,
                notWhitespaceValidator(),
                Validators.min(-1e6),
                Validators.max(1e6),
            ]),
            deductedUsd: new PersistentFormControl<number | null>(null, [Validators.min(-1e6), Validators.max(1e6)]),
            deductedCurrency: new PersistentFormControl<CurrencyInfo | null>(null, [Validators.required]),
        });
    }
}

export class PaymentRequestStatusChangeFormGroup extends PersistentFormGroup<{
    newStatusId: PersistentFormControl<PaymentRequestStatus | null>;
    deductedFormGroup: DeductedFormGroup;
    additionalInfo: PersistentFormControl<string>;
}> {
    constructor() {
        super({
            newStatusId: new PersistentFormControl<PaymentRequestStatus | null>(null, {
                validators: [Validators.required],
            }),
            deductedFormGroup: new DeductedFormGroup(),
            additionalInfo: new PersistentFormControl<string>('', {
                validators: maxLengthValidator(500),
            }),
        });
    }
}
